// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__38qYq","rootSmall":"AddTileButton_rootSmall__3Lapf"};